import { render } from "./TheList.vue?vue&type=template&id=2eefcd49&scoped=true&lang=pug"
import script from "./TheList.vue?vue&type=script&lang=js"
export * from "./TheList.vue?vue&type=script&lang=js"

import "./TheList.vue?vue&type=style&index=0&id=2eefcd49&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eefcd49"]])

export default __exports__